import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import {
  Dossier,
  SearchDashboardAPIParams,
  SearchDate,
  SuperAdminCosmosExportApiResponse,
  SuperAdminSmsStatisticsAPIParams,
  SuperAdminStatisticsAPIParams,
  SuperAdminSMSStatsAPIResponse,
  SuperAdminStatisticsApiResponse,
} from '@sc/data-access-models';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DashboardHttpService {
  private readonly dashboardStatsUrl = '/api/dashboard/stats';
  private readonly dashboardBrandsUrl = '/api/dashboard/brands';
  private readonly dashboardExportUrl = '/api/dashboard/export';
  private readonly dashboardNumberConnectionsUrl =
    '/api/dashboard/connections-counter';
  private readonly dashboardStatisticsUrl = '/api/dashboard/statistics';
  private readonly superAdminStatsUrl = '/api/super-admin/statistics';
  private readonly superAdminSmsStatsUrl = '/api/stats/sms';
  private readonly exportTimeout = '120000';

  constructor(private readonly httpClient: HttpClient) {}

  fetchStats(params: SearchDashboardAPIParams) {
    return this.httpClient.post<any>(this.dashboardStatsUrl, params, {
      headers: {
        requestName: 'dashboard-http fetchStats',
        timeout: this.exportTimeout,
      },
    });
  }

  exportData(params: SearchDashboardAPIParams) {
    return this.httpClient.post<{
      nb?: number;
      dossiers?: Dossier[];
      nextRequestId?: string;
    }>(this.dashboardExportUrl, params, {
      headers: {
        requestName: 'dashboard-http exportData',
        timeout: this.exportTimeout,
      },
    });
  }

  fetchBrands() {
    return this.httpClient.get<any>(this.dashboardBrandsUrl, {
      headers: { requestName: 'dashboard-http fetchBrands' },
    });
  }

  fetchNumberConnections(params: SearchDate) {
    return this.httpClient.post<any>(
      this.dashboardNumberConnectionsUrl,
      params,
      {
        headers: {
          requestName: 'dashboard-http fetchNumberConnections',
        },
      }
    );
  }

  fetchSuperAdminStats(
    params: SuperAdminStatisticsAPIParams
  ): Observable<SuperAdminStatisticsApiResponse> {
    return this.httpClient
      .post<any>(this.superAdminStatsUrl, params, {
        headers: {
          requestName: 'dashboard-http fetchSuperAdminStats',
          timeout: this.exportTimeout,
        },
      })
      .pipe(map((statsResult) => statsResult.result));
  }

  fetchSuperAdminCosmosData(
    params: SuperAdminStatisticsAPIParams
  ): Observable<SuperAdminCosmosExportApiResponse> {
    return this.httpClient
      .post<any>(`${this.superAdminStatsUrl}/cosmos-export-absolute`, params, {
        headers: {
          requestName: 'dashboard-http fetchSuperAdminCosmosDataAbsolute',
          timeout: this.exportTimeout,
        },
      })
      .pipe(map((exportResult) => exportResult.result));
  }

  fetchSuperAdminSmsStats(params: SuperAdminSmsStatisticsAPIParams) {
    return this.httpClient.post<SuperAdminSMSStatsAPIResponse>(
      this.superAdminSmsStatsUrl,
      params,
      {
        headers: {
          requestName: 'dashboard-http fetchSuperAdminSmsStats',
          timeout: this.exportTimeout,
        },
      }
    );
  }

  fetchStatistics(params: {
    brands: string[];
    searchDate: { start: string; end: string };
  }) {
    return this.httpClient.post<{
      fittersPct: number;
      daysPct: number;
      rvPct: number;
      oiPct: number;
      modifPct: number;
      addrPct: number;
      rawData: any;
    }>(this.dashboardStatisticsUrl, params, {
      headers: {
        requestName: 'dashboard-http fetchStatistics',
        timeout: this.exportTimeout,
      },
    });
  }
}
